import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import LayoutOne from "../layouts/LayoutOne";
import Seo from '../components/Seo';


const NotFound = () => {
  return (
    <Fragment>
      <Seo
        title="Page Not Found | Navy Seals Moving"
        description="The page you are looking for could not be found."
        noindex
      />
      <LayoutOne> 
        <div className="errorPage" style={{backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/images/slider1.jpg"})` }}>
          <div className="container">
            <div className="row">
              <div className="col-sm-12 text-right"> 
                    <h2>OOPS!</h2>
                    <span>404 - PAGE NOT FOUND</span>
                    <p>The page you are looking for was moved, removed, renamed or might never existed.</p>
                    <Link className="more-link" to={process.env.PUBLIC_URL + "/"}>
                      Go Home
                    </Link> 
              </div> 
            </div>
          </div>
        </div> 

        </LayoutOne>
    </Fragment>
  );
};

export default NotFound;
